<template>
	<div id="monthlyBasicSetup"  class="public-content">
		<!-- 公共form表单样式 -->
		<!-- 公共form表单样式 -->
		<div class="form-item-public" style="width:820px">	
			<el-form label-width="177px" label-position="right" inline :model="formData" :rules="basicRule" ref="basicRef">
				<el-form-item label="银行交易当月是否正常：" pro="bankMonTransaction">
					<el-select v-model="formData.bankMonTransaction" placeholder="请选择行业" size="small">
						<el-option lable="1" value="是"></el-option>
						<el-option lable="2" value="否"></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="银行交易本年是否正常：" prop="bankYearTransaction" >
					<el-select v-model="formData.bankYearTransaction" placeholder="请选择行业" size="small">
						<el-option lable="1" value="是"></el-option>
						<el-option lable="2" value="否"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="本年工资是否正常：" prop="wagesYearIsNormal">
					<el-select v-model="formData.wagesYearIsNormal" placeholder="请选择行业" size="small">
						<el-option lable="1" value="是"></el-option>
						<el-option lable="2" value="否"></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="本年个税基数是否正常：" prop="personalIncomeYearIsNormal" >
					<el-select v-model="formData.personalIncomeYearIsNormal" placeholder="请选择行业" size="small">
						<el-option lable="1" value="是"></el-option>
						<el-option lable="2" value="否"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="本年社保基数是否正常：" prop="socialYearIsNormal">
					<el-select v-model="formData.socialYearIsNormal" placeholder="请选择行业" size="small">
						<el-option lable="1" value="是"></el-option>
						<el-option lable="2" value="否"></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="本月工资是否正常：" prop="wagesIsNormal" >
					<el-select v-model="formData.wagesIsNormal" placeholder="请选择行业" size="small">
						<el-option lable="1" value="是"></el-option>
						<el-option lable="2" value="否"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="本月社保基数是否正常：" prop="socialIsNormal">
					<el-select v-model="formData.socialIsNormal" placeholder="请选择行业" size="small">
						<el-option lable="1" value="是"></el-option>
						<el-option lable="2" value="否"></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="本月个税基数是否正常：" prop="personalIncomeIsNormal" >
					<el-select v-model="formData.personalIncomeIsNormal" placeholder="请选择行业" size="small">
						<el-option lable="1" value="是"></el-option>
						<el-option lable="2" value="否"></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="工资备注：" prop="wagesRemarks">
					<el-input type="textarea" v-model="formData.wagesRemarks" resize="none" :autosize="{minRows: 5}" style="width: 632px;" placeholder="请输入工资备注!"></el-input>
				</el-form-item>
				
				<el-form-item label="社保基数备注："prop="socialRemarks">
					<el-input type="textarea" v-model="formData.socialRemarks"  resize="none" :autosize="{minRows:5}" style="width: 632px;" placeholder="请输入社保基数备注!"></el-input>
				</el-form-item>
				
				<el-form-item label="税基数备注：" prop="personalIncomeRemarks">
					<el-input type="textarea" v-model="formData.personalIncomeRemarks"  resize="none" :autosize="{minRows: 5}" style="width: 632px;" placeholder="请输入税基数备注!"></el-input>
				</el-form-item><br>
				
				<el-form-item label=" ">
					<el-button size="small" class='minButton' @click="saveUpdateBasic">保存</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import publicTable from '@/components/publicTable'
export default {
	components:{
		publicTable
	},
	data(){
		return {
			title:'每月基础设置',
			formData:{
				bankMonTransaction:'',
				bankYearTransaction:'',
				wagesYearIsNormal:'',
				wagesIsNormal:'',
				personalIncomeYearIsNormal:'',
				personalIncomeIsNormal:'',
				socialYearIsNormal:'',
				socialIsNormal:'',
				wagesRemarks:'',
				socialRemarks:'',
				personalIncomeRemarks:''
			},
			basicRule:{
				
			}
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			//快速访问
			this.$http.post('/itemProps/addItemProps',{

			}).then(res=>{
				console.log(res);
			});
		},
		saveUpdateBasic(){
			
		}

	},
	mounted() {
		
	},
}
</script>

<style lang="less" scoped>
	#monthlyBasicSetup{
		
	}
</style>



// WEBPACK FOOTER //
// src/pages/setting/monthlyBasicSetup.vue